// eslint-disable-next-line import/prefer-default-export
export const TWITCH_PANEL_EXTENSION_ID = 'bajpzyo9aekibuv6pr443am4vr10l9'
export const TWITCH_OVERLAY_EXTENSION_ID = 'sg72iavv7io5mt6ioyey61pmxqk31z'
